import { graphql } from "@apollo/react-hoc"
import CURRENT_USER_QUERY from "./CurrentUserQuery.gql.js"

const withCurrentUser = graphql(CURRENT_USER_QUERY, {
  props: ({ data }) => ({
    currentUserError: data.error,
    currentUserLoading: data.loading,
    currentUser: data.currentUser,
  }),
})

export default withCurrentUser
